import { render, staticRenderFns } from "./CheckLanguageModal.vue?vue&type=template&id=084a4ba8"
import script from "./CheckLanguageModal.vue?vue&type=script&lang=js"
export * from "./CheckLanguageModal.vue?vue&type=script&lang=js"
import style0 from "./CheckLanguageModal.vue?vue&type=style&index=0&id=084a4ba8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CheckLanguageModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports